import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import {TagTextData} from "../tag-text/tag-text.component";
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';

export interface BannerIconData {
    image_direction: string;
    background_color: string;
    picture: string;
    icon: IconData
    title: TagTextData
    image_height: number;
    image_width: number;
    text_data: TagTextData

    // deprecated tom
    text: string;
    tag: string;
}

export interface IconData {
    image: string
    size: string
    color: string
}

@Component({
    selector: 'banner-icon',
    template: `
        <div [ngClass]="(module.data.image_direction === 'right' ? 'right-image' : 'left-image')"
             [ngStyle]="{'background-color': module.data.background_color !== null ? module.data.background_color : 'transparent' }"
             class="banner-container eva-3-card -eva-3-shadow-line">
             <div *ngIf="hasPicture() || hasIcon()" class="image-container -eva-3-mr-md">
                <media-picture *ngIf="hasPicture()"
                    [mediaKey]="getMediaKey()!"
                    [imageHeight]="module.data.image_height ? module.data.image_height : 80"
                    [imageWidth]="module.data.image_width ? module.data.image_width : 100"
                    [previewMode]="'image'"
                    [resizeType]="'FIT'"
                    product="nymeria-gui"
                    [flow]="flow"
                ></media-picture>
                <i *ngIf="hasIcon()" [ngStyle]="{'color': module.data.icon.color}" class="-eva-3-icon-{{module.data.icon.size}} eva-3-icon-{{module.data.icon.image}}"></i>
             </div>
             <div class="banner-text-container" [ngClass]="{'centered-text': !hasPicture() && !hasIcon()}">
                <tag-text *ngIf="module.data.title" class="-eva-3-pb-xs" [data]="module.data.title"></tag-text>
                 <tag-text *ngIf="module.data.text_data" [data]="module.data.text_data"></tag-text>
<!--                 deprecated tom-->
                 <tag-text *ngIf="module.data.text && !module.data.text_data" [data]="{text: module.data.text, tag: module.data.tag}"></tag-text>
            </div>
        </div>
    `,
    styleUrls: ['./banner-icon.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BannerIconComponent extends AbstractComponent {
    public static MODULE_ID: string = 'BannerIconModule';
    @Input() override module: Module<BannerIconData>;
    @Input() override product;
    @Input() override flow;

    constructor(injector: Injector, private mediaPictureService: MediaPictureService) { 
        super(injector);
    }

    getMediaKey() {
        return this.mediaPictureService.getMediaKey(this.module.data.picture);
    }

    hasPicture(): boolean {
        return this.module.data.picture != null && this.module.data.picture !== '';
    }

    hasIcon(): boolean {
        return this.module.data.icon != null && this.module.data.icon.image !== '';
    }

    getModuleId(): string {
        return BannerIconComponent.MODULE_ID;
    }
}
